//导入request.js
import http from "@/utils/request"; //@==>src
import httptoken from "@/utils/index"; //@==>src
//登录
export const Logins = (data) => http.post("/login", data);
//获取角色id
export const getUserId = (data) => http.get("/getInfo", data);
export const getTokenUserId = (data) => httptoken.get("/getInfo", data);
// 获取学院列表
export const getColleges = (data) =>
  http.get("/teaching/no/token/dict/list", data);
export const getCollegesone = (data) =>
  http.get("/teaching/no/token/dict/" + data);
//获取实验列表
export const getExperiment = (data, page = 1, size = 10) =>
  http.post(`teaching/experiment/list/?pageNum=${page}&pageSize=${size}`, data);
export const getExperiment2 = (data) =>
  http.post("teaching/experiment/list/?pageSize=10000", data);
//获取实验视频资源列表
export const getAssets = (data) =>
  http.post("teaching/resource/listByType/?pageSize=10000", data);
//获取班级
export const getClass = (data) =>
  http.post("teaching/no/token/classes/list", data);
export const getClass2 = (data) =>
  http.post("teaching/no/token/classes/list?pageSize=10000", data);
//新增实验
export const addShiyan = (data) => http.post("teaching/experiment/add", data);
//编辑实验
export const bjShiyan = (data) => http.post("/teaching/experiment/edit", data);
//获取学习记录
//发表评论
export const fabiaopinglun = (data) => http.post("/teaching/comment", data);
//查询评论
// export const getpinglun=(params)=>http.post("/teaching/comment/list",params);
//查询成绩
export const getChengji = (data) =>
  http.post("/teaching/experiment/grade/list", data);
//教师评语
export const teacherPY = (data) =>
  http.post("/teaching/experiment/grade/add/teacher/comment", data);
//我的班级获取班级
export const getbanji = (data, pageNum, pageSize = 10) =>
  http.post(
    `/teaching/no/token/classes/list?pageNum=${pageNum}&pageSize=${pageSize}`,
    data,
  );
//获取学院
export const getxueyuan = (data) =>
  httptoken.get("/system/user/deptTree/", data);
//新增题目
export const addtimu = (data) => http.post("/system/bank", data);
export const updatetimu = (data) => http.put("/system/bank", data);
//新增试卷没有选择题目自动生成
export const addmrshijuan = (data) =>
  http.post("/examination/paper/computeScore", data);
export const putmrshijuan = (data) => http.put("/examination/paper", data);
//试卷获取关联模块
export function geteZhuangYe(data) {
  return http({
    url: "/teaching/experiment/list?pageSize=1000",
    method: "post",
    data,
  });
}
//新增试卷选择题目
export const addshijuan = (data) => http.post("/examination/paper", data);
// 点击跳转保存实验信息
export function saveExpinto(data) {
  return http({
    url: "/limit/data/save",
    method: "post",
    data,
  });
}
// 获取考试列表
// export const getkaoshiList = (params) => http.get("/examination/list", params);
// 删除考试列表
export const deletePaper = (data) => http.delete("/examination/" + data);
// 获取班级信息
export const getclass = (data) =>
  http.post("/teaching/no/token/classes/list", data);
export const getclass2 = (data) =>
  http.post("/teaching/no/token/classes/list?pageSize=10000", data);
// 新增考试
export const addkaoshiapi = (data) => http.post("/examination", data);
// 获取成绩列表
export function getresult(data, params) {
  return http({
    url: "/examination/grade/class/list",
    method: "post",
    data,
    params,
  });
}
// 获取考试列表
export function getkaoshiList(params) {
  return http({
    url: "/examination/list",
    method: "get",
    params,
  });
}
// 获取错题列表
export function getwroning(params) {
  return http({
    url: "/statistics/list",
    method: "post",
    params,
  });
}
// 获取学生成绩列表
export function getsturesult(data) {
  return http({
    url: "/examination/grade/student/list",
    method: "post",
    data,
  });
}
export function getXXjl(data, params) {
  return http({
    url: "/teaching/experiment/grade/list",
    method: "post",
    data,
    params,
  });
}
export const deletegrade = (data) =>
  http.delete("/teaching/experiment/grade/" + data);
// 获取实验详情
export function getexpxiangqing(data) {
  return http({
    url: "/teaching/experiment/" + data,
    method: "get",
  });
}
// 查看教师团队
export function getteacherlist(data) {
  return http({
    url: "/teaching/experimentTeam/getInfo/" + data,
    method: "get",
  });
}
// 查看教师团队
export function seeqquanxian(data, id) {
  return http({
    url: "/teaching/experimentUser/experimentUserGetInfo/" + data + "/" + id,
    method: "get",
  });
}
// 预约申请
export function yuyueexp(data) {
  return httptoken({
    url: "/teaching/experimentUser",
    method: "post",
    data,
  });
}
// 获取预约申请
export function getyuyueexp() {
  return httptoken({
    url: "/teaching/experimentUser/getInfoNoList",
    method: "get",
    params: { pageSize: 10000 },
  });
}
// 审批实验
export function putyuyueexp(data) {
  return httptoken({
    url: "/teaching/experimentUser",
    method: "put",
    data,
  });
}
export function putyuyuecourse(data) {
  return httptoken({
    url: "/teaching/courseAndUser",
    method: "put",
    data,
  });
}

// 生成加密
export function encryption(data) {
  return http({
    url: "/teaching/accredit/generateAuthorizationCode",
    method: "post",
    data,
  });
}

//获取实验排序序号
export function getExperimentSortNo() {
  return http({
    url: "/teaching/experiment/getSortNo",
    method: "get",
  });
}
//获取课程排序序号
export function getCourseSortNo() {
  return httptoken({
    url: "/teaching/myCourse/getSortNo",
    method: "get",
  });
}
//获新增用户浏览实验
export function addBrowse(data) {
  return httptoken({
    url: "/teaching/browse",
    method: "post",
    data,
  });
}
//根据专业获取老师列表
export function getTeacherList(deptId) {
  return httptoken({
    url: "/teaching/classes/getTeacherList?deptId=" + deptId,
    method: "get",
  });
}

//重置密码
export function resetPassword(id) {
  return httptoken({
    url: "/teaching/student/resetPassword/" + id,
    method: "get",
  });
}
// 获取用户信息
export function getUserInfo(id) {
  return httptoken({
    url: "/user/center/getUserAccountInfo?userId=" + id,
    method: "get",
  });
}
